<template>
  <export-email-report-dialog
    title="Enviar relatório de cashback"
    description="O relatório de consumo de cashback é enviado, através de um e-mail, para a caixa de entrada dos endereços de e-mail adicionados abaixo. Um arquivo CSV contendo todas as informações detalhadas do histórico de cashback é enviado em anexo ao e-mail."
    :exportReportFn="exportReport"
    :disabled="disabled"
    async
    @file-format="getFileFormat"
  />
</template>

<script>
import { MUTATION_CREATE_CONSUMED_CASHBACK } from '@/modules/mobile/cashback/graphql'

import ExportEmailReportDialog from '@/components/export-email-report/ExportEmailReportDialog.vue'
export default {
  name: 'ExportCashbackConsumptionDialog',
  components: {
    ExportEmailReportDialog,
  },
  props: {
    filters: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    fileFormat: 'CSV',
  }),
  methods: {
    getFileFormat(value) {
      this.fileFormat = value
    },
    async exportReport(emails) {
      return this.$apollo.mutate({
        mutation: MUTATION_CREATE_CONSUMED_CASHBACK,
        fetchPolicy: 'no-cache',
        variables: {
          filters: this.filters,
          emails,
          fileFormat: this.fileFormat,
        },
        context: {
          uri: this.$microservicesUrls['asyncJobs'],
        },
      })
    },
  },
}
</script>
